module.exports = __webpack_public_path__ + "img/20220323_194419.4245b307.jpg";